export default __webpack_public_path__ + "static/media/Mist.1dc2a625.mp4";